import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetManagersQuery } from "../../hooks/useGetManagersQuery";
import { updateManager } from "../../services/school/manager/updateManager";
import { Key_managers } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { ManagerType } from "../../types/Manager";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";


const columnNamesMap: { [key: string]: string } = {
  fullname:"Nome", 
  university:"Instituição de Ensino Superior", 
  faculty:"Unidade orgânica", 
  departament:"Departamento", 
  course:"Curso", 
  role:"Cargo", 
};

export const Managers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItem, setDeleteItem] = useState<ManagerType | null>(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetManagersQuery({ PageNumber: currentPage, PageSize: 400 });

  const mutationDelete = useMutation(updateManager, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_managers);
      toast.success('Gestor eliminado');
    },
    onError: () => {
      toast.error("Erro ao eliminar o gestor.")
    }
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createManager)
  }
  const handleEdit = async (manager: ManagerType) => {
  };
  const handleDelete = (manager: ManagerType) => {
    try {
      manager.status = false;
      mutationDelete.mutateAsync(manager)
    } catch (error: any) {
      toast.error(`${mutationDelete.error ?? error?.message}`);

    }
  };
  const openDeleteItemDialog = (s: ManagerType) => {
    setDeleteItem(s);
  };
  const confirmDeleteItem = async () => {
    if (deleteItem) {
        await handleDelete(deleteItem!)
    }
};
  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (manager: any) => handleEdit(manager),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: (manager: any) => openDeleteItemDialog(manager),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
    <Lists
      status={status}
      TableComponent={() =>
        <TableComponent
          columns={Object.keys(columnNamesMap)}
          items={data?.items}
          options={options}
          columnNamesMap={columnNamesMap}
          totalPages={data?.totalPages || 1}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          emptyMessage="Ainda não existem gestores registados."
        />
      }
      handleClickCreate={undefined}
    />
     <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        description="O gestor deixará de estar vinculado à instituição. Pretende continuar?"
        confirmLabel="Eliminar"
        item={deleteItem}
        onConfirm={confirmDeleteItem} 
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
}
